(() => {
  if (window.preaSearchRangeSyncReady) return;
  window.preaSearchRangeSyncReady = true;

  const toNumber = (value, fallback = 0) => {
    const number = Number.parseFloat(value);
    return Number.isFinite(number) ? number : fallback;
  };

  const countDecimals = (value) => {
    const text = String(value || '');
    const decimalPart = text.split('.')[1];
    return decimalPart ? decimalPart.length : 0;
  };

  const formatPriceInputValue = (value, decimalPlaces) => {
    const formatted = value.toFixed(decimalPlaces);
    return formatted.replace(/\.?0+$/, '');
  };

  const syncRangeToInputs = (range) => {
    const scope = range.closest('[data-prea-price-range]');
    if (!scope) return;

    const minRange = scope.querySelector('[data-prea-price-range-input="min"]');
    const maxRange = scope.querySelector('[data-prea-price-range-input="max"]');
    const minInput = scope.querySelector('[data-prea-price-input="min"]');
    const maxInput = scope.querySelector('[data-prea-price-input="max"]');
    if (!minRange || !maxRange || !minInput || !maxInput) return;

    const maxLimit = toNumber(maxRange.max);
    let minValue = toNumber(minRange.value);
    let maxValue = toNumber(maxRange.value, maxLimit);
    const decimalPlaces = Math.max(
      countDecimals(minRange.step),
      countDecimals(maxRange.step),
      countDecimals(maxRange.max)
    );

    if (minValue > maxValue) {
      if (range.dataset.preaPriceRangeInput === 'min') {
        maxValue = minValue;
        maxRange.value = String(maxValue);
      } else {
        minValue = maxValue;
        minRange.value = String(minValue);
      }
    }

    minInput.value = formatPriceInputValue(minValue, decimalPlaces);
    maxInput.value = formatPriceInputValue(maxValue, decimalPlaces);
    minInput.dispatchEvent(new Event('input', { bubbles: true }));
  };

  const syncInputToRange = (input) => {
    const scope = input.closest('[data-prea-price-range]');
    if (!scope) return;

    const target = input.dataset.preaPriceInput;
    const range = scope.querySelector(`[data-prea-price-range-input="${target}"]`);
    if (!range) return;

    range.value = input.value || (target === 'min' ? range.min : range.max);
  };

  document.addEventListener(
    'input',
    (event) => {
      const range = event.target.closest('[data-prea-price-range-input]');
      if (range) {
        event.stopPropagation();
        syncRangeToInputs(range);
        return;
      }

      const input = event.target.closest('[data-prea-price-input]');
      if (input) {
        syncInputToRange(input);
      }
    },
    true
  );
})();

(function () {
  if (window.__preaSearchToolbarInitialized) return;
  window.__preaSearchToolbarInitialized = true;

  var MOTION_DURATION = 340;
  var SORT_DURATION = 270;
  var layoutRaf = null;
  var layoutMetricsForce = false;
  var ROOT_SELECTOR = '.template-search, .collection-grid-section';
  var MOBILE_FILTER_QUERY = '(max-width: 1199px)';

  function getFacetRoot(element) {
    return element ? element.closest(ROOT_SELECTOR) : document.querySelector(ROOT_SELECTOR);
  }

  function getFacetRoots() {
    return document.querySelectorAll(ROOT_SELECTOR);
  }

  function isMobileFilterDrawer() {
    return window.matchMedia(MOBILE_FILTER_QUERY).matches;
  }

  function setFilterDrawerScrollLock() {
    var hasOpenDrawer = isMobileFilterDrawer() && Boolean(document.querySelector('[data-prea-filter-menu].is-open'));
    document.documentElement.classList.toggle('prea-search-filter-drawer-open', hasOpenDrawer);
  }

  function setToolbarStickyOffset() {
    var offset = 0;
    var selectors = [
      'sticky-header',
      '.shopify-section-header-sticky',
      '#shopify-section-header.shopify-section-header-sticky',
      '.section-header.shopify-section-header-sticky'
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var header = document.querySelector(selectors[i]);
      if (!header) continue;

      var style = window.getComputedStyle(header);
      var rect = header.getBoundingClientRect();

      if (
        rect.height > 0 &&
        rect.bottom > 0 &&
        (style.position === 'sticky' || style.position === 'fixed')
      ) {
        offset = Math.round(rect.height);
        break;
      }
    }

    document.documentElement.style.setProperty('--prea-search-toolbar-sticky-top', offset + 'px');

    getFacetRoots().forEach(function (root) {
      root.style.setProperty('--prea-search-toolbar-sticky-top', offset + 'px');
    });
  }

  function setFilterPanelMaxHeight(options) {
    var force = options && options.force;

    getFacetRoots().forEach(function (root) {
      var shell = root.querySelector('.prea-search-toolbar-shell');
      if (!shell) return;

      if (!force && root.querySelector('[data-prea-filter-menu].is-open, [data-prea-filter-menu].is-closing')) return;

      var shellRect = shell.getBoundingClientRect();
      var viewportSpace = window.innerHeight - shellRect.bottom - 12;
      var available = Math.max(0, viewportSpace);

      root.style.setProperty('--prea-filter-panel-max-height', available + 'px');
    });
  }

  function resetFilterPanelEdgeLock(root) {
    root.style.removeProperty('--prea-filter-panel-y-shift');
    root.style.removeProperty('--prea-filter-panel-top-clip');
  }

  function setRootPixelProperty(root, property, value) {
    var nextValue = value + 'px';

    if (root.style.getPropertyValue(property) !== nextValue) {
      root.style.setProperty(property, nextValue);
    }
  }

  function setFilterPanelEdgeLock() {
    getFacetRoots().forEach(function (root) {
      if (isMobileFilterDrawer()) {
        resetFilterPanelEdgeLock(root);
        return;
      }

      var menu = root.querySelector(
        '[data-prea-filter-menu][open], [data-prea-filter-menu].is-open, [data-prea-filter-menu].is-closing'
      );

      if (!menu) {
        resetFilterPanelEdgeLock(root);
        return;
      }

      var shell = root.querySelector('.prea-search-toolbar-shell');
      var panel = menu.querySelector('.prea-search-filter-panel');

      if (!shell || !panel) {
        resetFilterPanelEdgeLock(root);
        return;
      }

      var shellRect = shell.getBoundingClientRect();
      var rootRect = root.getBoundingClientRect();
      var panelHeight = panel.getBoundingClientRect().height;
      var overflowAmount = shellRect.bottom + panelHeight - rootRect.bottom;
      var overflow = overflowAmount > 1 ? Math.ceil(overflowAmount) : 0;

      setRootPixelProperty(root, '--prea-filter-panel-y-shift', -overflow);
      setRootPixelProperty(root, '--prea-filter-panel-top-clip', overflow);
    });
  }

  function scheduleLayoutMetrics(options) {
    if (options && options.force) {
      layoutMetricsForce = true;
    }

    if (layoutRaf) return;

    layoutRaf = window.requestAnimationFrame(function () {
      var force = layoutMetricsForce;

      layoutRaf = null;
      layoutMetricsForce = false;
      setToolbarStickyOffset();
      setFilterPanelMaxHeight({ force: force });
      setFilterPanelEdgeLock();
    });
  }

  function setFilterLabels(menu) {
    if (!menu) return;

    var chips = menu.querySelectorAll('.prea-search-filter__active-chip');
    var count = chips.length;
    var suffix = count > 0 ? ' (' + count + ')' : '';
    var showLabel = menu.querySelector('[data-prea-filter-show-label]');
    var hideLabel = menu.querySelector('[data-prea-filter-hide-label]');

    if (showLabel) showLabel.textContent = 'Show filters' + suffix;
    if (hideLabel) hideLabel.textContent = 'Hide filters' + suffix;
  }

  function syncAllFilterLabels() {
    document.querySelectorAll('[data-prea-filter-menu]').forEach(setFilterLabels);
  }

  function setSortMenuLayerState() {
    var hasOpenSort = Boolean(document.querySelector('[data-prea-sort-menu].is-open'));

    document.documentElement.classList.toggle('prea-search-sort-menu-open', hasOpenSort);

    getFacetRoots().forEach(function (root) {
      root.classList.toggle('prea-search--sort-open', Boolean(root.querySelector('[data-prea-sort-menu].is-open')));
    });
  }

  function openFilterMenu(menu) {
    if (!menu) return;

    var root = getFacetRoot(menu);
    window.clearTimeout(menu.__preaCloseTimer);

    document.querySelectorAll('[data-prea-sort-menu].is-open').forEach(closeSortMenu);

    scheduleLayoutMetrics({ force: true });

    if (root) {
      root.classList.remove('prea-search--filters-closing');
    }

    menu.open = true;
    menu.classList.remove('is-closing');

    window.requestAnimationFrame(function () {
      menu.classList.add('is-open');

      if (root) {
        root.classList.add('prea-search--filters-open');
      }

      setFilterDrawerScrollLock();
    });
  }

  function closeFilterMenu(menu) {
    if (!menu || (!menu.open && !menu.classList.contains('is-open'))) return;

    var root = getFacetRoot(menu);
    window.clearTimeout(menu.__preaCloseTimer);

    if (root) {
      root.classList.remove('prea-search--filters-open');
      root.classList.add('prea-search--filters-closing');
    }

    menu.classList.remove('is-open');
    menu.classList.add('is-closing');
    setFilterDrawerScrollLock();

    menu.__preaCloseTimer = window.setTimeout(function () {
      menu.classList.remove('is-closing');
      menu.open = false;

      if (root) {
        root.classList.remove('prea-search--filters-closing');
        resetFilterPanelEdgeLock(root);
      }

      setFilterDrawerScrollLock();
    }, MOTION_DURATION);
  }

  function toggleFilterMenu(menu) {
    if (!menu) return;

    if (menu.classList.contains('is-open')) {
      closeFilterMenu(menu);
    } else {
      openFilterMenu(menu);
    }
  }

  function openSortMenu(menu) {
    if (!menu) return;

    document.querySelectorAll('[data-prea-sort-menu]').forEach(function (otherMenu) {
      if (otherMenu !== menu) {
        closeSortMenu(otherMenu);
      }
    });

    document.querySelectorAll('[data-prea-filter-menu].is-open').forEach(closeFilterMenu);

    window.clearTimeout(menu.__preaCloseTimer);
    menu.open = true;
    menu.classList.remove('is-closing');

    window.requestAnimationFrame(function () {
      menu.classList.add('is-open');
      setSortMenuLayerState();
    });
  }

  function closeSortMenu(menu) {
    if (!menu || (!menu.open && !menu.classList.contains('is-open'))) return;

    window.clearTimeout(menu.__preaCloseTimer);
    menu.classList.remove('is-open');
    menu.classList.add('is-closing');
    setSortMenuLayerState();

    menu.__preaCloseTimer = window.setTimeout(function () {
      menu.classList.remove('is-closing');
      menu.open = false;
      setSortMenuLayerState();
    }, SORT_DURATION);
  }

  function toggleSortMenu(menu) {
    if (!menu) return;

    if (menu.classList.contains('is-open')) {
      closeSortMenu(menu);
    } else {
      openSortMenu(menu);
    }
  }

  function syncInitialState() {
    document.querySelectorAll('[data-prea-filter-menu]').forEach(function (menu) {
      setFilterLabels(menu);

      if (menu.open) {
        menu.classList.add('is-open');

        var root = getFacetRoot(menu);
        if (root) {
          root.classList.add('prea-search--filters-open');
        }
      }
    });

    document.querySelectorAll('[data-prea-sort-menu]').forEach(function (menu) {
      if (menu.open) {
        menu.classList.add('is-open');
      }
    });

    setSortMenuLayerState();
    setFilterDrawerScrollLock();
    scheduleLayoutMetrics();
  }

  document.addEventListener(
    'click',
    function (event) {
      var filterSummary = event.target.closest('[data-prea-filter-menu] > summary');
      var sortSummary = event.target.closest('[data-prea-sort-menu] > summary');
      var filterBackdrop = event.target.closest('[data-prea-filter-backdrop]');
      var filterClose = event.target.closest('[data-prea-filter-close]');

      if (filterSummary) {
        event.preventDefault();
        toggleFilterMenu(filterSummary.closest('[data-prea-filter-menu]'));
        return;
      }

      if (filterBackdrop) {
        event.preventDefault();
        closeFilterMenu(filterBackdrop.closest('[data-prea-filter-menu]'));
        return;
      }

      if (filterClose) {
        event.preventDefault();
        closeFilterMenu(filterClose.closest('[data-prea-filter-menu]'));
        return;
      }

      if (sortSummary) {
        event.preventDefault();
        toggleSortMenu(sortSummary.closest('[data-prea-sort-menu]'));
        return;
      }

      var sortOption = event.target.closest('[data-prea-sort-option]');

      if (sortOption) {
        var sortMenu = sortOption.closest('[data-prea-sort-menu]');
        var sortInput = sortMenu ? sortMenu.querySelector('[data-prea-sort-input]') : null;
        var sortLabel = sortMenu ? sortMenu.querySelector('[data-prea-sort-label]') : null;
        var selectedValue = sortOption.getAttribute('data-prea-sort-value');

        if (!sortInput || !selectedValue) return;

        sortInput.value = selectedValue;

        if (sortLabel) {
          sortLabel.textContent = sortOption.textContent.trim();
        }

        sortMenu.querySelectorAll('[data-prea-sort-option]').forEach(function (button) {
          var isActive = button === sortOption;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        closeSortMenu(sortMenu);
        sortInput.dispatchEvent(new Event('input', { bubbles: true }));
        return;
      }

      document.querySelectorAll('[data-prea-filter-menu].is-open').forEach(function (menu) {
        if (!menu.contains(event.target)) {
          closeFilterMenu(menu);
        }
      });

      document.querySelectorAll('[data-prea-sort-menu].is-open').forEach(function (menu) {
        if (!menu.contains(event.target)) {
          closeSortMenu(menu);
        }
      });
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('[data-prea-filter-menu].is-open').forEach(closeFilterMenu);
    document.querySelectorAll('[data-prea-sort-menu].is-open').forEach(closeSortMenu);
  });

  window.addEventListener('resize', function () {
    scheduleLayoutMetrics({ force: true });
    setFilterDrawerScrollLock();
  });
  window.addEventListener('scroll', function () {
    // Collection toolbars scroll normally. Measure only while a panel is open.
    if (document.querySelector('.template-search, .collection-grid-section [data-prea-filter-menu].is-open')) {
      scheduleLayoutMetrics();
    }
  }, { passive: true });

  document.addEventListener('DOMContentLoaded', function () {
    syncInitialState();
    scheduleLayoutMetrics();
  });

  document.addEventListener('shopify:section:load', function () {
    syncInitialState();
    scheduleLayoutMetrics();
  });

  document.addEventListener('prea:search-facets-updated', function () {
    syncAllFilterLabels();
    setSortMenuLayerState();
    setFilterDrawerScrollLock();
    scheduleLayoutMetrics();
  });

  scheduleLayoutMetrics();
})();
